import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { api } from '../utils/api';
import './Login.css';

export default function VerifyMagicLink() {
  const [searchParams] = useSearchParams();
  const { login: ctxLogin } = useAuth();
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) navigate('/login');
  }, [token, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); setLoading(true);
    try {
      const data = await api.verifyMagicLink(token, code);
      ctxLogin(data.token, data.user);
      navigate('/eventos');
    } catch (err) { setError(err.message); }
    finally { setLoading(false); }
  };

  return (
    <div className="login-page">
      <div className="login-bg-runes">ᚠᚢᚦᚨᚱᚲᚷᚹᚺᚾᛁᛃᛇᛈᛉᛊᛏᛒᛖᛗᛚᛜᛞᛟ</div>
      <div className="login-card">
        <div className="login-brand">
          <div className="login-rune">ᚠ</div>
          <h1 className="login-title">Aldealix</h1>
          <p className="login-sub">La Aldea Celta · Verificación</p>
        </div>
        <div className="login-divider" />
        <div className="alert alert-info" style={{ marginBottom: '1.2rem' }}>
          <span>📧</span> Introduce el código de 6 dígitos que te hemos enviado por email.
        </div>
        {error && <div className="alert alert-error"><span>⚠</span> {error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Código de acceso</label>
            <input className="form-input" type="text" value={code}
              onChange={e => setCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              required autoFocus placeholder="123456"
              style={{ fontSize: '1.5rem', letterSpacing: '.5rem', textAlign: 'center' }} />
          </div>
          <button type="submit" className="btn btn-primary btn-full btn-lg"
            disabled={loading || code.length !== 6}>
            {loading ? <><span className="spinner" /> Verificando...</> : 'Entrar a la Aldea'}
          </button>
        </form>
      </div>
    </div>
  );
}
